import { lazy } from "react";
import { createBrowserRouter, Navigate } from "react-router-dom";

import AdminModule from "../layouts/index";
import RelatedReports from "../pages/relatedReports";
import QuickSightReport from "../pages/relatedReports/QuickSightReport";
import type { AcMenuItem } from "../types/acMenu";
import { buildDynamicIframeRoutes } from "./buildDynamicIframeRoutes";
const NewAclsList = lazy(() => import("../pages/admin/acl/NewAclsList"));
const AddNewAcl = lazy(() => import("../pages/admin/acl/AddNewAcl"));
const AuditReportsWrap = lazy(() => import("../pages/audit_new/AuditReportsWrap"));
const ImportUser = lazy(() => import("../pages/admin/user/ImportUser"));
const ImportAcl = lazy(() => import("../pages/admin/acl/ImportAcl"));
const ImportRole = lazy(() => import("../pages/admin/role/ImportRole"));
const ImportGroup = lazy(() => import("../pages/admin/group/ImportGroup"));
const DistributionList = lazy(
  () => import("../pages/admin/distribution/DistributionList")
);
const AddDistribution = lazy(
  () => import("../pages/admin/distribution/AddDistribution")
);
const ViewDistribution = lazy(
  () => import("../pages/admin/distribution/ViewDistribution")
);

const ImportDistribution = lazy(() => import("../pages/admin/distribution/ImportDistribution"));
const ClientList = lazy(() => import("../pages/admin/client/ClientList"));
const AddClient = lazy(() => import("../pages/admin/client/AddClient"));
const ViewClient = lazy(() => import("../pages/admin/client/ViewClient"));
const ScimConfigPage = lazy(() => import("../pages/admin/scim/ScimConfigPage"));

const UserList = lazy(() => import("../pages/admin/user/UserList"));
const GroupList = lazy(() => import("../pages/admin/group/GroupList"));
const RoleList = lazy(() => import("../pages/admin/role/RoleList"));
const AddUser = lazy(() => import("../pages/admin/user/AddUser"));
const ViewUser = lazy(() => import("../pages/admin/user/ViewUser"));
const AddGroup = lazy(() => import("../pages/admin/group/AddGroup"));
const ViewGroup = lazy(() => import("../pages/admin/group/ViewGroup"));
const AddRole = lazy(() => import("../pages/admin/role/AddRole"));
const ViewRole = lazy(() => import("../pages/admin/role/ViewRole"));

const MenuManagerList = lazy(
  () => import("../pages/customized/menuManager/MenuManagerList")
);
const GridManagerList = lazy(
  () => import("../pages/customized/gridManager/GridManagerList")
);
const FormManagerList = lazy(
  () => import("../pages/customized/formManager/FormManagerList")
);
const FormFiledsList = lazy(
  () => import("../pages/customized/formManager/FormFiledsList")
);
const WizardManagerList = lazy(
  () => import("../pages/customized/wizardManager/WizardManagerList")
);

const NotificationManager = lazy(() => import("../pages/notifications"));
const WorkflowManager = lazy(() => import("../pages/workflow"));
const KnowledgeManager = lazy(() => import("../pages/knowledge"));
const TaskManager = lazy(() => import("../pages/process/taskManager"));
const TemplateManager = lazy(() => import("../pages/process/templateManager"));
const TemplateAutoLauncher =  lazy(() => import("../pages/process/templateAutoLauncher"));
const DocsManager = lazy(() => import("../pages/docs"));
const EventManager = lazy(() => import("../pages/eventManager"));
const UiManager = lazy(() => import("../pages/uiManager"));
const ArchiveManager = lazy(() => import("../pages/archiveManager"));
const PlanAndAutomation = lazy(() => import("../pages/planAndAutomation"));

const routesForm = [
  //Impact
  // {
  //   path: '/user-access-management',
  //   element: <AdminModule />,
  //   children: [
  //     {
  //       path: 'users',
  //       element: <UserList />
  //     },
  //     {
  //       path: 'add-user',
  //       element: <AddUser />
  //     },
  //     {
  //       path: 'edit-user',
  //       element: <AddUser />
  //     },
  //     {
  //       path: 'view-user',
  //       element: <ViewUser />
  //     },
  //     {
  //       path: 'add-user-group',
  //       element: <AddGroup />
  //     },
  //     {
  //       path: 'edit-user-group',
  //       element: <AddGroup />
  //     },
  //     {
  //       path: 'view-user-group',
  //       element: <ViewGroup />
  //     },
  //     {
  //       path: '',
  //       element: <UserList />
  //     }
  //   ]
  // },
  {
    path: "/configuration",
    element: <AdminModule />,
    children: [
      {
        path: "",
        element: <Navigate to="menu-manager" replace />,
      },
      {
        path: "/configuration/form-manager",
        element: <FormManagerList />,
      },
      {
        path: "/configuration/form-manager/fields/:formId",
        element: <FormFiledsList />,
      },
      {
        path: "/configuration/grid-manager",
        element: <GridManagerList />,
      },
      {
        path: "/configuration/menu-manager",
        element: <MenuManagerList />,
      },
      {
        path: "/configuration/menu-manager/domain/:domainId/module/:moduleId",
        element: <MenuManagerList />,
      },
      {
        path: "/configuration/menu-manager/domain/:domainId/module/:moduleId/group/:groupId",
        element: <MenuManagerList />,
      },
      {
        path: "/configuration/wizard-manager",
        element: <WizardManagerList />,
      },
      {
        path: "/configuration/wizard-manager/domain/:domainId/module/:moduleId",
        element: <WizardManagerList />,
      },
      {
        path: "/configuration/wizard-manager/domain/:domainId/module/:moduleId/wizard/:wizardId",
        element: <WizardManagerList />,
      },
    ],
  },
  {
    path: "/user-access-management",
    element: <AdminModule />,
    children: [
      {
        path: "",
        element: <Navigate to="users" replace />,
      },
      {
        path: "/user-access-management/acl",
        element: <NewAclsList />,
      },
      {
        path: "/user-access-management/acl/add-acl",
        element: <AddNewAcl />,
      },
      {
        path: "/user-access-management/acl/edit-acl",
        element: <AddNewAcl />,
      },
      {
        path: "/user-access-management/acl/view-acl",
        element: <AddNewAcl />,
      },
      {
        path: "/user-access-management/acl/import-acl",
        element: <ImportAcl />,
      },
      {
        path: "/user-access-management/user-groups",
        element: <GroupList />,
      },
      {
        path: "/user-access-management/roles",
        element: <RoleList />,
      },
      {
        path: "/user-access-management/roles/add-role",
        element: <AddRole />,
      },
      {
        path: "/user-access-management/roles/edit-role",
        element: <AddRole />,
      },
      {
        path: "/user-access-management/roles/view-role",
        element: <ViewRole />,
      },
      {
        path: "/user-access-management/roles/import-role",
        element: <ImportRole />,
      },
      {
        path: "/user-access-management/users",
        element: <UserList />,
      },
      {
        path: "/user-access-management/users/add-user",
        element: <AddUser />,
      },
      {
        path: "/user-access-management/users/edit-user",
        element: <AddUser />,
      },
      {
        path: "/user-access-management/users/view-user",
        element: <ViewUser />,
      },
      {
        path: "/user-access-management/users/import-user",
        element: <ImportUser />,
      },
      {
        path: "/user-access-management/user-groups/add-user-group",
        element: <AddGroup />,
      },
      {
        path: "/user-access-management/user-groups/edit-user-group",
        element: <AddGroup />,
      },
      {
        path: "/user-access-management/user-groups/view-user-group",
        element: <ViewGroup />,
      },
      {
        path: "/user-access-management/user-groups/import-user-group",
        element: <ImportGroup />,
      },
      {
        path: "/user-access-management/distribution",
        element: <DistributionList />,
      },
      {
        path: "/user-access-management/distribution/add-distribution",
        element: <AddDistribution />,
      },
      {
        path: "/user-access-management/distribution/edit-distribution",
        element: <AddDistribution />,
      },
      {
        path: "/user-access-management/distribution/view-distribution",
        element: <ViewDistribution />,
      },
      {
        path: "/user-access-management/distribution/import-distribution",
        element: <ImportDistribution />,
      },
      {
        path: "/user-access-management/clients",
        element: <ClientList />,
      },
      {
        path: "/user-access-management/clients/add-client",
        element: <AddClient />,
      },
      {
        path: "/user-access-management/clients/edit-client",
        element: <AddClient />,
      },
      {
        path: "/user-access-management/clients/view-client",
        element: <ViewClient />,
      },
      {
        path: "/user-access-management/scim",
        element: <ScimConfigPage />,
      },
    ],
  },
  {
    path: "/audit",
    element: <AdminModule />,
    children: [
      {
        path: "",
        element: <AuditReportsWrap />,
      },
    ],
  },
  {
    path: "/notifications",
    element: <AdminModule />,
    children: [
      {
        path: "",
        element: <NotificationManager></NotificationManager>,
      },
    ],
  },
  {
    path: "/workflow-manager",
    element: <AdminModule />,
    children: [
      {
        path: "",
        element: <WorkflowManager />,
      },
    ],
  },
  {
    path: "/knowledge-manager",
    element: <AdminModule />,
    children: [
      {
        path: "",
        element: <KnowledgeManager />,
      },
    ],
  },
  {
    path: "/bpmn",
    element: <AdminModule />,
    children: [
      {
        path: "",
        element: <Navigate to="task-manager" replace />,
      },
      {
        path: "task-manager",
        element: <TaskManager />,
      },
      {
        path: "template-manager",
        element: <TemplateManager />,
      },
      {
        path: "auto-launcher",
        element: <TemplateAutoLauncher />,
      }
    ],
  },
  {
    path: "/docs-manager",
    element: <AdminModule />,
    children: [
      {
        path: "",
        element: <DocsManager />,
      },
    ],
  },
  {
    path: "/uimanager",
    element: <AdminModule />,
    children: [
      {
        path: "",
        element: <UiManager />,
      },
    ],
  },
  {
    path: "/archivemanager",
    element: <AdminModule />,
    children: [
      {
        path: "",
        element: <ArchiveManager />,
      },
    ],
  },
  {
    path: "/plan-and-automation",
    element: <AdminModule />,
    children: [
      {
        path: "",
        element: <PlanAndAutomation />,
      },
    ],
  },
  {
    path: "/event-manager",
    element: <AdminModule />,
    children: [
      {
        path: "",
        element: <EventManager />,
      },
    ],
  },
  {
    path: "/reports",
    element: <AdminModule />,
    children: [
      {
        path: "",
        element: <Navigate to="overview" replace />,
      },
      {
        path: "overview",
        element: <RelatedReports />,
      },
      {
        path: "quicksight-reports/:id",
        element: <QuickSightReport />,
      },
    ],
  },
];

const catchAllRoutes = [
  {
    path: "/*",
    element: <Navigate to="/reports" replace />,
  },
  {
    path: "//*",
    element: <Navigate to="/user-access-management/users" replace />,
  },
];

export function createAppRouter(dynamicModules: AcMenuItem[] = []) {
  return createBrowserRouter([
    ...routesForm,
    ...buildDynamicIframeRoutes(dynamicModules),
    ...catchAllRoutes,
  ]);
}

/** @deprecated Prefer createAppRouter(matched) after bootstrap — static-only mount is unsafe for deep links */
const Router = createAppRouter([]);

export { Router, routesForm };
